import CometMarquee from 'comet-marquee';
import 'comet-marquee/dist/comet-marquee.css';

const clientsMarqueeArr = document.querySelectorAll('.clients-marquee');
clientsMarqueeArr.forEach((clientsMarqueeEl, i) => {
  const items = clientsMarqueeEl.querySelectorAll('.comet-marquee-item');
  const clientsMarquee = new CometMarquee(clientsMarqueeEl, {
    speed: 35,
    pauseOnHover: true,
    initialShift: true,
    pauseOnInvisible: true,
    syncPause: true,
    repeatCount: 8,
    forceAnimation: items.length >= 2,
    forceAnimationWidth: items.length >= 2 ? 2 : 1,
    reverse: !!(i % 2),
  });
})